import { RequestConfig } from '@/interface'

const PRIFIX = 'ypgl/gzpz/'
const ruleConfigurationConfig: RequestConfig = {
  // 批量开启关闭
  plkqgb: {
    url: `${PRIFIX}plkqgb`,
    method: 'get'
  },
  // 批量设置
  plsz: {
    url: `${PRIFIX}plsz`,
    method: 'post'
  },
  // 首页规则列表
  sygzlb: {
    url: `${PRIFIX}sygzlb`,
    method: 'post'
  },
  // 税收编码查询
  ssbmdlcx: {
    url: `${PRIFIX}ssbmdlcx`,
    method: 'get'
  }
}
export default ruleConfigurationConfig
